import DropdownDetail from "./DropdownDetail";

export default DropdownDetail;
